import type { paths } from '@pba/types-openapi-node';
import type { AxiosResponse } from 'axios';
import { getNodeApiAxiosInstance } from '#client';
import type { ComplexRequest } from '#models';
import type { ChatroomDataObject } from '#models/services';
import { routes } from '#routes';

type SetChatroomStatusRequest =
  paths['/chatrooms/{chatroomId}/status']['post']['requestBody']['content']['application/json'];
type SetChatroomStatusRouteParameters = paths['/chatrooms/{chatroomId}/status']['post']['parameters']['path'];

export const setChatroomStatus = async ({
  body,
  config,
  routeParams: { chatroomId },
}: ComplexRequest<SetChatroomStatusRequest, never, SetChatroomStatusRouteParameters>) =>
  getNodeApiAxiosInstance().post<ChatroomDataObject, AxiosResponse<ChatroomDataObject>>(
    routes.chatrooms.status(chatroomId),
    body,
    config,
  );
